import { useRouter } from "next/router";
import { useUser } from "@/auth/useUser";
import { useConfirm } from "@/components/providers/confirmProvider";
import { ClientMembershipsQuery } from "@/graphql/queries/clientMemberships.graphql.types";
import useIsOTPClientPage from "@/hooks/client/useIsOTPClientPage";

export default function useClientMembership(
  membership: ClientMembershipsQuery["clientMembership"][number],
  clientId: string
) {
  const { medspa } = useUser();
  const {
    query: { medspaSlug },
    push,
  } = useRouter();
  const isOTPClientPage = useIsOTPClientPage();
  const { getConfirm } = useConfirm();

  const cancelMembership = async () =>
    push(`/${medspa}/clients/${clientId}/memberships/${membership.id}/cancel`);

  // Change Membership Credit Card
  const changeMembershipCreditCard = async () => {
    const ok = await getConfirm({
      title: "Change Membership Credit Card",
      description:
        "This membership is using the default card for the client. To change the default card, please navigate to the client wallet.",
      discardButtonText: "Go back",
      confirmButtonText: "Go to client wallet",
    });

    if (!ok) return;

    return push(`/${medspa}/clients/${clientId}/wallet`);
  };

  const viewMembershipAgreement = () => {
    if (isOTPClientPage && medspaSlug) {
      push(`/client/${medspaSlug}/memberships/${membership.id}`);
    } else {
      push(`/${medspa}/clients/${clientId}/memberships/${membership.id}`);
    }
  };

  return {
    cancelMembership,
    changeMembershipCreditCard,
    viewMembershipAgreement,
  };
}
